var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_723_7037)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.3996 24.0001C46.3996 11.6289 36.3708 1.6001 23.9996 1.6001C11.6284 1.6001 1.59961 11.6289 1.59961 24.0001C1.59961 36.3713 11.6284 46.4001 23.9996 46.4001C36.3708 46.4001 46.3996 36.3713 46.3996 24.0001Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_723_7037)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2231 17.7289H18.5347V34.0871H13.2231V17.7289ZM15.8797 9.6001C16.4878 9.60081 17.0821 9.77439 17.5874 10.0989C18.0926 10.4234 18.4862 10.8842 18.7183 11.4231C18.9504 11.962 19.0107 12.5548 18.8914 13.1265C18.7722 13.6983 18.4788 14.2233 18.0483 14.6351C17.6179 15.047 17.0697 15.3273 16.4732 15.4405C15.8766 15.5538 15.2584 15.4949 14.6968 15.2713C14.1351 15.0477 13.6552 14.6695 13.3177 14.1845C12.9802 13.6994 12.8004 13.1293 12.8008 12.5463C12.8011 12.159 12.8809 11.7755 13.0358 11.4178C13.1907 11.0601 13.4176 10.7352 13.7036 10.4616C13.9895 10.188 14.3288 9.97111 14.7022 9.82329C15.0756 9.67547 15.4757 9.59963 15.8797 9.6001ZM21.8624 34.0871H27.1632V25.9956C27.1632 23.8625 27.5839 21.7963 30.3448 21.7963C33.0624 21.7963 33.101 24.2358 33.101 26.1342V34.0871H38.4008V25.1154C38.4008 20.7097 37.4108 17.324 32.0412 17.324C31.033 17.2877 30.0334 17.5143 29.149 17.9796C28.2645 18.445 27.5284 19.1317 27.0189 19.9666H26.9498V17.7289H21.8624V34.0871Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_723_7037"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_723_7037"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.6,
    height: 24.487,
    fill: "white",
    transform: "translate(12.8008 9.6001)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedinIcon.d4014ac52c3f60136cc444898e4e0443.svg";
export { ForwardRef as ReactComponent };